var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-dialog',{attrs:{"value":_vm.dialog,"width":500,"fullscreen":_vm.isMobile,"title":_vm.$t('ai.rec_title')},on:{"input":val => { if (!val) _vm.hide() },"close":_vm.hide}},[(_vm.studentId)?_c('ai-recommendation-card',{key:_vm.studentId,attrs:{"student-id":_vm.studentId,"embedded":""},on:{"close":_vm.hide}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }